import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { panalytSuperAdminRoutes } from '../common/routes';
import { DEFAULT_LANDING_PAGE } from '../common/v2/constants';
import {
  useEffectiveRoleViewAuthorizationServiceContext,
  useLatestPreferencesContext,
} from '../common/v2/context/contexts';
import { DashboardContextProvider } from '../common/v2/context/DashboardContextProvider';
import { LegacyDomainScopedContextProvider } from '../common/v2/context/LegacyDomainScopedContextProvider';
import { PanalytSuperAdminContextProvider } from '../common/v2/context/PanalytSuperAdminContextProvider';
import { PrivateRoute } from './PrivateRoute';

export const PanalytSuperAdminRoutes = () => {
  const authorizationService =
    useEffectiveRoleViewAuthorizationServiceContext();
  const latestPreferences = useLatestPreferencesContext();
  const companyLandingPage =
    latestPreferences.customLandingPage ?? DEFAULT_LANDING_PAGE;
  const enabledPages = panalytSuperAdminRoutes().filter(
    (r) => r.isEnabled?.() ?? true
  );

  console.log2('PanalytSuperAdmin', { enabledPages });

  return (
    <DashboardContextProvider>
      <LegacyDomainScopedContextProvider>
        <PanalytSuperAdminContextProvider>
          <Switch>
            {enabledPages.map((route) => (
              <PrivateRoute
                key={route.id}
                component={route.comp()}
                {...route}
                guard={() => {
                  const isPanalytSuperAdmin =
                    authorizationService.canSeePanalytSuperAdminMenu();
                  if (!isPanalytSuperAdmin) {
                    return <Redirect from="/" to={companyLandingPage} />;
                  }
                }}
              />
            ))}
            <Redirect from="*" to={companyLandingPage} />
          </Switch>
        </PanalytSuperAdminContextProvider>
      </LegacyDomainScopedContextProvider>
    </DashboardContextProvider>
  );
};
